<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <button id="printButton" v-show="printShow" v-on:click="onPrintButtonClick" type="button" class="btn btn-warning" style="float:right">
        Print
      </button>

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-sectionProductSubscription">
          <PagePLApplicationFormLease
            ref="pageTableLease"
            v-on:lease-season-select="onApplicationLeaseSelect"
            v-on:lease-season-remove="onApplicationLeaseRemove"
            v-on:lease-parker-add="onApplicationParkerAdd" />
        </div>

        <div
          slot="jt-form-slot-sectionApproval"
          class="table-responsive"
          v-show="approvalItem.length">
          <h3>Available Bay Summary</h3>
          <hr>
          <table
            class="table table-bordered"
            ref="pageTableApproval" >
            <tr>
              <th>Product</th>
              <th>Available Bays</th>
              <th>Application Requested Bays</th>
              <th>Summary</th>
            </tr>
            <tr v-for="item of approvalItem" v-bind:key="'requested_' + item.product" v-bind:style="item.status === 'OK' ? 'background-color:#dbffdb' : 'background-color:#ffb4aa'">
              <td>{{item.product}}</td>
              <td>{{item.available}}</td>
              <td>{{item.request}}</td>
              <td>{{item.status}}</td>
            </tr>
          </table>
        </div>

        <AppForm
          slot="jt-form-slot-sectionCustomerCompany"
          v-show="pageCustomerCompany"
          ref="companyForm" 
          v-bind:formParameter="COMPANY_PARAM" />

        <AppForm
          slot="jt-form-slot-sectionCustomerPersonal"
          v-show="pageCustomerPersonal"
          ref="personalForm" 
          v-bind:formParameter="PERSONAL_PARAM" />
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <div id="button-bottom">

        <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
          Cancel
        </button>

        <TemplateButton v-show="hasAddPermission() && pageShowAdd && pageCanAdd" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
          Submit Application
        </TemplateButton>

        <TemplateButton v-show="hasEditPermission() && pageShowEdit && pageCanEdit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
          Submit Application
        </TemplateButton>

        <div class="btn-group" v-show="(hasApprovePermission() || hasRejectPermission() || hasVoidPermission()) && approvalShow">
          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Approval Action
          </button>
          <div class="dropdown-menu">
            <a v-show="hasApprovePermission() && approvalShowApprove" class="dropdown-item" href="#" v-on:click.prevent="onApplicationApproveClick" >Approve Application</a>
            <a v-show="hasRejectPermission() && approvalShowReject" class="dropdown-item" href="#" v-on:click.prevent="onApplicationRejectClick" >Reject Application</a>
            <a v-show="hasApprovePermission() && approvalShowPending" class="dropdown-item" href="#" v-on:click.prevent="onApplicationPendingClick" >Pending Approval</a>
            <a v-show="hasVoidPermission() && approvalShowVoid" class="dropdown-item" href="#" v-on:click.prevent="onApplicationVoidClick" >VOID Application</a>
          </div>
        </div>
        
        <TemplateButton v-show="false && pageShowPaid" v-on:click="onApplicationPaidClick" type="button" class="btn btn-danger">
          PAID
        </TemplateButton>

      </div>
      
      <AppModalForm 
        ref="pageApprovalModal" 
        v-bind:formParameter="[]"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <div>
          {{ approvalText }}
        </div>
        <div v-show="approvalReject">
          <br>
          <label>{{ approvalRejectLabel }}</label>
          <input class="form-control" v-model="approvalRejectReason">
          <label class="error form-control-feedback">{{approvalRejectReasonError}}</label>
        </div>
        <TemplateButton slot="modal-footer-after" @click="pageApprovalModalConfirm" type="button" class="btn btn-success">
          Confirm
        </TemplateButton>
      </AppModalForm>

      <AppModalForm 
        ref="parkerModal" 
        v-bind:formParameter="PARKER_PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onParkerModalAddDataClick"
        v-bind:modalShowEdit="false"
        v-bind:modalShowDelete="false" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import CustomerCompanyParam from "@/components/Param/CustomerCompanyParam"
import CustomerPersonalParam from "@/components/Param/CustomerPersonalParam"
import PagePLApplicationFormLease from "@/components/Page/ParkingLicense/PagePLApplicationFormLease";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: 'applicationType',
    text: 'Application Type',
    form_select: ['Company', 'Personal'],
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionCustomerProfile',
    form_section: 'Personal Profile',
    form_edit_hide: true,
  },
  {
    key: 'customerID',
    text: 'Personal Name',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.nationalID ? `${data.name} (${data.nationalID})` : data.name,
      formatSelectOptionAttr: (data) => data.id === -1 ? { style : "color: #1e88e5;" } : null,
    },
    form_chosen: true,
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionCustomerCompany',
    form_div: true,
  },
  {
    key: 'sectionCustomerPersonal',
    form_div: true,
  },
  {
    key: 'sectionApplicationInformation',
    form_section: 'Application Information',
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => {
        let option = data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name;
        if(data._disabled) {
          option += ' (' + data._disabled + ')';
        }
        return option;
      },
      formatSelectOptionAttr: (data) => data._disabled ? {disabled: 1} : {},
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationCarparkTenant',
    text: 'Car Park Tenant',
    form_radio: [{1:'Yes - <span class="help-block text-muted"><small>You would be able to choose products allocated for tenant, also entitlement products assigned to you (if any).</small></span>'}, {0:'No - <span class="help-block text-muted"><small>You would be able to choose products allocated for non-tenant.</small></span>'}],
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: '_commencementDate',
    text: 'Commencement Date',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
    form_muted: 'Must not more than 3 months from current month. Otherwise, kindly apply later.',
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: 'paymentPlan',
    text: 'Payment Plan',
    form_radio: [
      {1:'Monthly'}, 
      {2:'Quarterly'},
      {3:'Half-Year'},
      {4:'Annually'}
    ],
  },
  {
    key: 'totalPayable',
    text: 'Total Amount Payable (RM)',
    form_input_attr: {
      disabled: true,
    },
    form_input_validation: []
  },
  {
    key: 'sectionBilling',
    form_section: 'Billing & Correspondence Instructions',
  },
  {
    key: 'accessCard',
    text: 'Deliver Parking Access Card to:',
    form_add_hide: true,
    form_edit_hide: true,
    form_hide: true,
    form_radio: [{0:'Correspondence Address'}, {1:'Company Address'}],
    form_default: 0,
    form_input_validation: []
  },
  {
    key: 'agreeEmailBill',
    text: 'I agree that all my bills will be sent to my email address',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'agreeEmailCorrespondences',
    text: 'I authorize that all correspondences will be sent to my email address',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'agreeTNCandPP',
    text: 'I accept the <a href="/plTnCview" target="_blank">Terms and Conditions</a> and <a href="/plPPview" target="_blank">Privacy Policy</a>',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionApproval',
    form_html: () => '',
  },
];

const PARKER_PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'name',
    text: 'Parker Full Name',
    table_popup: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'mobile',
    text: 'Mobile No.',
    form_phone: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_input_attr: {
      placeholder: '60XXXXXXXXX',
    },
  },
  {
    key: 'car1',
    text: 'Car Plate',
  },
  {
    key: 'email',
    text: 'Email',
    form_email: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
];

const COMPANY_PARAM = CustomerCompanyParam.getParam(true);
const PERSONAL_PARAM = CustomerPersonalParam.getParam(true).filter(k => k.key !== 'nationality');

const PARAM_MAP = helper.transformParamToMap(PARAM);
const COMPANY_PARAM_MAP = helper.transformParamToMap(COMPANY_PARAM);
const PERSONAL_PARAM_MAP = helper.transformParamToMap(PERSONAL_PARAM);

export default {
  name: "PagePLApplicationForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    AppModalForm,
    PagePLApplicationFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Application', url: '/plApplication' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,
      PARKER_PARAM,

      COMPANY_PARAM,
      COMPANY_PARAM_MAP,
      PERSONAL_PARAM,
      PERSONAL_PARAM_MAP,

      pageTitle: null,
      pageApplication: null,
      pageShowData: false,
      pageShowAdd: false,
      pageCanAdd: false,
      pageShowEdit: false,
      pageCanEdit: false,

      pageLicenseAll: null,
      pageApplicationAll: null,

      pageCarpark: null,
      pageCarparkSeason: undefined,
      pageZone: undefined,
      pageCustomer: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      printShow: false,
      approvalShow: false,
      approvalShowApprove: false,
      approvalShowReject: false,
      approvalShowPending: false,
      approvalShowVoid: false,
      pageShowPaid: false,

      pageCustomerCompany: null,
      pageCustomerPersonal: null,

      approvalItem: [],

      approvalText: null,
      approvalReject: false,
      approvalRejectLabel: 'Reason',
      approvalRejectReason: null,
      approvalRejectReasonError: null,

      setParkerAtIndexWithAddParkerModalData: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(helper.checkRoleIsParker()) {
      // if(helper.checkRoleIsCompany()) {
      //   PARAM_MAP['applicationType'].form_select = ['Company']
      // } else {
      //   PARAM_MAP['applicationType'].form_select = ['Personal']
      // }
      PARAM_MAP['customerID'].form_select.formatSelectOptionText = (data) => {
        if(data.id === -1) {
          return data.name;
        }
        let text = data.name;
        if(data.nationalID) {
          text += ' (' + data.nationalID + ')';
        }
        if(data.operatorName) {
          text += ' (Operator: ' + data.operatorName + ')';
        } else {
          text += ' (Operator: NA)';
        }
        return text;
      }
    }
    
    if(!this.$route.path.includes('Force')) {
      this.$nextTick(() => {
        helper.setSidebar('/plApplication');
      });
    }
    this.hideFormFromKey('sectionCustomerProfile');
    this.loadTenant();
  },
  methods: {
    hideFormFromKey(key) {
      // // TODOO temporarily allow all car park for testing
      // commencementDateValidate = () => true;
      // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark || []);

      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'accessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load customer, tenant, carpark & zone
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTenant = response.data;
          this.loadEntitlement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        });
    },
    loadEntitlement() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/entitlement',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageEntitlement = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCarpark = response.data;
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },
    
    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        let feedbackItem = 'parking license application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?applicationID=' + applicationID + '&type1=application',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['applicationID'] = temp['applicationID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['paymentPlan'] = temp['paymentPlan'];
            application['_commencementDate'] = helper.formatDate(temp['commencementDate']);
            application['accessCard'] = temp['data1'];
            application['status'] = temp['status2'];
            application['agreeEmailBill'] = 1;
            application['agreeEmailCorrespondences'] = 1;
            application['agreeTNCandPP'] = 1;
            application['lease'] = response.data;

            // response.data.forEach(k => k['isParkAide'] = parseInt(k['data3']));

            application['_customer'] = this.pageCustomer.find(k => helper.compareID(k.id, application['customerID']));
            if(application['_customer']) {
              if(application['_customer'].isCompany) {
                application['applicationType'] = 'Company';
              } else {
                application['applicationType'] = 'Personal';
              }
            }

            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'], false);

            // status = 0 -> display "Pending approval"
            // status = 1 -> display "Pending initial payment"
            // status = 2 -> display "Active"
            // status = 3 -> display "Rejected"
            // status = 4 -> display "VOID"

            this.printShow = true;

            // TODO kw1 show/hide approval action based on status
            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = true;
                this.approvalShowPending = false;
                this.approvalShowVoid = true;
                this.pageCanEdit = true;
            } else if(application['status'] === 'Pending Initial Payment') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = false;
                this.approvalShowVoid = true;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};

                // TODO kw1 hardcode change status to PAID button
                this.pageShowPaid = true;
            } else if(application['status'] === 'Rejected') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = true;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            } else if(application['status'] === 'Void') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = true;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            } else {//if(application['status'] === 'Active') {
                this.approvalShow = false;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = false;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            }

            this.onApplicationTypeChange();
            this.onApplicationCustomerChange();

            this.pageTitle = 'Parking License Application ' + (this.pageApplication = helper.plFormPLANum(application['applicationID'], application['carparkID']));
            this.pageShowData = true;
            
            this.loadApplicationCustomer();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageCanAdd = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        let selectedCustomer = this.pageCustomer.find(k => helper.compareID(k.id, this.$route.query.customerID));
        if(selectedCustomer) {
          if(selectedCustomer.isCompany) {
            tempData['applicationType'] = 'Company';
          } else {
            tempData['applicationType'] = 'Personal';
          }
        }
        tempData['customerID'] = this.$route.query.customerID || tempData['customerID'];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];

        tempData['paymentPlan'] = 1;
        tempData['_commencementDate'] = helper.formatDate(moment().add(7, 'days'));

        this.$refs['pageForm'].setForm(true, tempData);
        this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData.lease, true);

        this.onApplicationTypeChange();
        this.onApplicationCarparkOrCustomerChange();

        this.pageTitle = 'Parking License Application';
        this.pageShowData = true;

        this.loadAllApplication();
      }
    },

    loadAllApplication() {
      let formData = this.$refs['pageForm'].formData;
      let feedbackItem = 'parking license application list'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/requestgroup?type1=application&status1=Pending Approval',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageApplicationAll = response.data;

          this.loadAllLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadAllLicense() {
      let formData = this.$refs['pageForm'].formData;
      let feedbackItem = 'parking license list'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageLicenseAll = response.data;

          if(formData['customerID']) {
            this.onApplicationCustomerChange();
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    
    loadApplicationCustomer() {
      let formData = this.$refs['pageForm'].formData;
      let tempData = formData['_customer'];//this.pageCustomer.find(k => helper.compareID(k.id, formData['customerID']));
      if(tempData) {
        if(tempData['address1']) {
          this.loadCity();
        } else if(tempData['contact1']) {
          this.loadApplicationCustomerContact();
        } else {
          this.loadApplicationCustomerComplete();
        }
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Problem loading customer profile data.');
      }
    },
    loadCity() {
      let feedbackItem = 'customer address city'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/city/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          helper.inputSelectSetOption(this.COMPANY_PARAM_MAP['companyAddressCityID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalCorrespondenceAddressCityID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalPermanentAddressCityID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['companyAddressCityID'], response.data);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadState() {
      let feedbackItem = 'customer address state'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/state/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          helper.inputSelectSetOption(this.COMPANY_PARAM_MAP['companyAddressStateID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalCorrespondenceAddressStateID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalPermanentAddressStateID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['companyAddressStateID'], response.data);
          this.loadCountry();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCountry() {
      let feedbackItem = 'customer address country'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/country/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          helper.inputSelectSetOption(this.COMPANY_PARAM_MAP['companyAddressCountryID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalCorrespondenceAddressCountryID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['personalPermanentAddressCountryID'], response.data);
          helper.inputSelectSetOption(this.PERSONAL_PARAM_MAP['companyAddressCountryID'], response.data);
          this.loadApplicationCustomerAddress();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadApplicationCustomerAddress() {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer address data...');
      this.$http
          .get(
            helper.SERVER_URL + '/api2/address/' + formData['_customer']['address1'],
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = helper.parseAddress(response);
            if(tempData) {
              formData['_customer'] = Object.assign(tempData, formData['_customer']);
              if(tempData['contact1']) {
                this.loadApplicationCustomerContact();
              } else {
                this.loadApplicationCustomerComplete();
              }
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading customer address data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer address data'));
          })
    },
    loadApplicationCustomerContact() {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer contact data...');
      this.$http
          .get(
            helper.SERVER_URL + '/api2/contact/' + formData['_customer']['contact1'],
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = helper.parseContact(response);
            if(tempData) {
              formData['_customer'] = Object.assign(tempData, formData['_customer']);
              this.loadApplicationCustomerComplete();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading customer contact data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer contact data'));
          })
    },
    loadApplicationCustomerComplete() {
      let formData = this.$refs['pageForm'].formData;
      let tempData = formData['_customer'];
      if(tempData.isCompany) {
        this.$refs['companyForm'].setForm(false, this.pageCustomerCompany = tempData);
        formData['applicationType'] = 'Company';
      } else {
        this.$refs['personalForm'].setForm(false, this.pageCustomerPersonal = tempData);
        formData['applicationType'] = 'Personal';
      }
      // this.loadApplicationData(formData['applicationData']);
      this.loadLeaseData();
    },

    loadLeaseData() {
      let formData = this.$refs['pageForm'].formData;
      if(!formData['carparkID']) {
        return;
      }

      if(!formData['customerID']) {
        return;
      }

      if(!this.pageCarparkSeason) {
        this.loadCarparkSeasonSetting();
        return;
      }

      if(!this.pageBay) {
        this.loadBay();
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.pageCarparkSeason.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('Unable to load car park product setting');
        return;
      }

      if(this.pageSeason.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('No product available');
        return;
      }

      if(this.pageParker.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('No parker available');
        return;
      }

      this.calculateParkingFees();
    },
    loadCarparkSeasonSetting() {
      let carparkID = this.$refs['pageForm'].formData['carparkID'];
      if(!carparkID) {
        return;
      }

      this.pageCarparkSeason = null;

      let feedbackItem = 'car park season setting';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + carparkID + '/seasonSetting/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          let pageCarparkSeason = response.data[0];

          if(!pageCarparkSeason) {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
            this.hideFormFromKey('applicationCarparkTenant');
            return;
          }

          if(this.$refs['pageForm'].formIsAdd) {
            if(pageCarparkSeason.SuspendApplication) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park has been suspended from Parking Application.");
              this.hideFormFromKey('applicationCarparkTenant');
              return true;
            }

            if(pageCarparkSeason.startDate && pageCarparkSeason.startDate > new moment().unix()) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park doesn't start operating until " + helper.formatDate(pageCarparkSeason.startDate));
              this.hideFormFromKey('applicationCarparkTenant');
              return true;
            }

            if(pageCarparkSeason.endDate && pageCarparkSeason.endDate < new moment().unix()) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park has stopped operating since " + helper.formatDate(pageCarparkSeason.endDate));
              this.hideFormFromKey('applicationCarparkTenant');
              return true;
            }
          }

          this.pageCarparkSeason = pageCarparkSeason;
          
          this.setCarparkSeasonApplicableDate();

          if(this.$refs['pageForm'].formIsAdd) {
            if(this.pageCarparkSeason['ParkaideOnly']) {
              this.$refs['pageTableLease'].setLeaseParkaideEnable(false);
              this.$refs['pageForm'].formData['lease'].forEach(k => k['isParkAide'] = 1);
            } else if(this.pageCarparkSeason['ParkaideEnable']) {
              this.$refs['pageTableLease'].setLeaseParkaideEnable(true);
            } else {
              this.$refs['pageTableLease'].setLeaseParkaideEnable(false);
              this.$refs['pageForm'].formData['lease'].forEach(k => k['isParkAide'] = 0);
            }
          }

          try {
            let self = this;
            commencementDateValidate = function(date) {
              if(!self.$route.path.includes('Force')) {
                if(date < moment().startOf('month').toDate()) {
                  return false;
                }
              }
              
              if(date > moment().add(2, 'M').endOf('month').toDate()) {
                return false;
              }

              let pageCarparkSeason = self.pageCarparkSeason;
              if(!pageCarparkSeason.CommencementDate1 && !pageCarparkSeason.CommencementDate2) {
                return true;
              }

              if(date.getDate() === pageCarparkSeason.CommencementDate1 || date.getDate() === pageCarparkSeason.CommencementDate2) {
                return true;
              }

              return false;
            }
            $('#jt-form-input-_commencementDate').datepicker('update');
          } catch (e) {
          }

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          this.hideFormFromKey('applicationCarparkTenant');
        });
    },
    setCarparkSeasonApplicableDate() {
      let formData = this.$refs['pageForm'].formData;
      if(formData['status'] === undefined) {
        if(this.pageCarparkSeason.CommencementDate1 || this.pageCarparkSeason.CommencementDate2) {
          let date = helper.parseDateTime(formData['_commencementDate']).date();
          if(date === this.pageCarparkSeason.CommencementDate1 || date === this.pageCarparkSeason.CommencementDate2) {
            return;
          }

          let today = moment();

          if(this.pageCarparkSeason.CommencementDate1) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate1);
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate2) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate2);
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate1) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate1);
            nextApplicableDate.add(1, 'month');
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate2) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate2);
            nextApplicableDate.add(1, 'month');
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }
        }
      }
    },
    loadBay() {
      this.hideFormFromKey('applicationCarparkTenant');

      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['pageForm'].formData['carparkID'];
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageBay = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeason() {
      this.hideFormFromKey('applicationCarparkTenant');

      if(this.$refs['pageForm'].formIsAdd) {
        this.$refs['pageTableLease'].setSeasonData(null);
      }

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.pageSeason.forEach(k => {
              let zone = this.pageZone.find(j => j.id === k.zoneID) || {};
              k['_zone'] = zone;
              k['_zoneName'] = zone.name;
              k['_bayAvailable'] = this.pageBay.filter(j => j.seasonID === k.id && !j.leaseID).length;
            });

            this.onApplicationCarparkTenantChange();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('paymentPlan');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('applicationCarparkTenant');

      if(this.$refs['pageForm'].formIsAdd) {
        // this.$refs['pageTableLease'].setParkerData(null);
      }

      let customerID = this.$refs['pageForm'].formData['customerID'];
      
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;

            if(this.setParkerAtIndexWithAddParkerModalData !== null) {
              let modalParkerAddForm = this.$refs['parkerModal'].$refs['modalForm'].formData;
              let newlyAddedParker = response.data.find(j => j.name === modalParkerAddForm.name && j.email === modalParkerAddForm.email && j.car1 === modalParkerAddForm.car1) || {};
              this.$refs['pageForm'].formData['lease'][this.setParkerAtIndexWithAddParkerModalData]['parkerID'] = newlyAddedParker.id;
              this.setParkerAtIndexWithAddParkerModalData = null;
            }
            
            this.$refs['pageTableLease'].setParkerData(this.pageParker);
            this.loadLeaseData();
          // } else {
          //   this.$refs['pageTableLease'].setParkerData(null);
          //   this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          // }
        })
        .catch(error => {
          this.$refs['pageTableLease'].setParkerData(null);
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['totalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let paymentPlan = parseInt(formData['paymentPlan']);
      if(paymentPlan === undefined || paymentPlan === null) {
        return;
      }

      let _commencementDateText = formData['_commencementDate'];
      if(_commencementDateText === undefined || _commencementDateText === null || _commencementDateText === '') {
        return;
      }

      let _commencementDate = helper.parseDateTime(_commencementDateText);
      let daysInMonth = _commencementDate.daysInMonth();
      let startDay = _commencementDate.date();

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let formStatus = this.$refs['pageForm'].formData.status;
      let requestedSeason = {};

      let error = false;
      let tandemCalculated = [];
      formData.lease.forEach((leaseData, leaseIndex) => {
        this.$refs['pageTableLease'].onParkerChange(leaseIndex);

        leaseData['commencementDate'] = _commencementDate.unix();
        leaseData['paymentPlan'] = paymentPlan;

        if(!leaseData['seasonID']) {
          return;
        }

        let leaseSeason = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID']));
        leaseData['leaseProduct'] = leaseSeason;
        leaseData['leaseProductZone'] = leaseSeason['_zone'];
        leaseData['leaseProductName'] = leaseSeason['name'] + ` - ${leaseSeason['_zone'].name}`;
        leaseData['seasonFeesID'] = null;

        requestedSeason[leaseData['seasonID']] = requestedSeason[leaseData['seasonID']] || {
          name: leaseData['leaseProductName'],
          entitleOnly: leaseSeason['entitleOnly'],
          count: 0,
        };
        requestedSeason[leaseData['seasonID']].count++;

        if(!this.pageFees[leaseData['seasonID']]) {
          return;
        }
        
        let product;
        let earliestFeesDate = 0;
        if(this.$refs['pageForm'].formIsAdd) {
          // get season fees based on commencement date
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= _commencementDate.unix()) {
                product = temp;
                break;
              }
              if(!earliestFeesDate || earliestFeesDate > temp.startDate) {
                earliestFeesDate = temp.startDate;
              }
            }
          }
        } else {
          product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
          // if(!product || product.startDate > _commencementDate.unix()) {
          if(!product) {
            product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
            if(!product) {
              for(let temp of this.pageFees[leaseData['seasonID']]) {
                if(temp.startDate <= _commencementDate.unix()) {
                  product = temp;
                  break;
                }
                if(!earliestFeesDate || earliestFeesDate > temp.startDate) {
                  earliestFeesDate = temp.startDate;
                }
              }
            }
          }
        }
        if(!product) {
          leaseData['seasonFees'] = null;
          error = true;
          if(earliestFeesDate) {
            this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(leaseData['leaseProductName'] + ' product do not have product fee at this commencement date, this product fee start on ' + helper.formatDate(earliestFeesDate));
          } else {
            this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(leaseData['leaseProductName'] + ' product do not have product fee');
          }
          $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
          return;
        }

        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['seasonFeesID'] = product.id;
        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(paymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['monthly'];
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['quarterly'];
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['halfYearly'];
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['annually'];
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        if(!error) {
          this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(null);
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          if(!leaseData['pairID'] || !tandemCalculated.includes(leaseData['pairID'])) {
            leaseTotal[k] += leaseData[k];
          }
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
        tandemCalculated.push(leaseData['pairID']);
      });

      if(!helper.checkRoleIsParker()) {
        if(formStatus === 'Pending Approval' || formStatus === 'Pending') {
          this.approvalItem = [];
          for(let requestedSeasonID in requestedSeason) {
            let requestedSeasonItem = requestedSeason[requestedSeasonID];
            let requestedBay = requestedSeasonItem.count;
            let availableBay;
            if(requestedSeasonItem.entitleOnly) {
              let entitlement = this.pageEntitlement.find(j => 
                helper.compareID(j['seasonID'], requestedSeasonID) 
                && helper.compareID(j['tenantID'], formData['tenant']['id']))
              if(!entitlement || !entitlement.bayCount) {
                availableBay = 0;
              } else {
                let usedEntitlementBay = this.pageBay.filter(j => j.seasonID === requestedSeasonID && j.leaseID && helper.compareID(j['customerID'], formData['customerID'])).length;
                availableBay = entitlement.bayCount - usedEntitlementBay;
              }
            } else {
              availableBay = this.pageBay.filter(k => helper.compareID(k.seasonID, requestedSeasonID) && !k.leaseID).length;
            }
            
            this.approvalItem.push({
              product: requestedSeasonItem['name'],
              available: availableBay,
              request: requestedBay,
              status: availableBay >= requestedBay ? 'OK' : 'NG',
            });
          }

          let ngItem = this.approvalItem.find(k => k.status === 'NG');
          if(ngItem) {
            this.$refs['pageFeedback'].setFeedbackError('Please increase Bay Count allocation in ' + ngItem.product);
            this.approvalShowApprove = false;
          } else {
            this.approvalShowApprove = true;
          }
        }
      }

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      this.$refs['pageTableLease'].$forceUpdate();

      formData['totalPayable'] = leaseTotal['leaseProductInitialPaymentText'];
      this.$refs['pageForm'].$forceUpdate();

      this.hideFormFromKey(null);
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      let url = this.$route.query.pending ? helper.WEB_URL + '/plApplicationPending' : helper.WEB_URL + '/plApplication';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onPrintButtonClick() {
      $('#printButton').hide();
      $('#jt-form-div-sectionApproval').hide();
      $('#button-bottom').hide();
      window.print();
      $('#printButton').show();
      $('#jt-form-div-sectionApproval').show();
      $('#button-bottom').show();
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addTenant({});
        } else {
          this.editApplication({});
        }
      }
    },
    onApplicationParkerAdd(index) {
      this.$refs['pageForm'].formData['lease'][index]['parkerID'] = null;
      this.$refs['parkerModal'].setModalOpen(true, 'Add New Parker', {index: index});
    },
    async onParkerModalAddDataClick(selectedData) {
      let feedbackItem = selectedData.name;

      selectedData.customerID = this.$refs['pageForm'].formData['customerID'];
      
      this.$refs['parkerModal'].setModalLoading('Adding parker ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/customer/' + selectedData.customerID + '/parker',
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['parkerModal'].setModalClose();
          this.$refs['pageForm'].formData['lease'][selectedData.index]['parkerID'] = response.data[0].id;

          this.setParkerAtIndexWithAddParkerModalData = selectedData.index;
          this.loadParker();
        })
        .catch(error => {
          this.$refs['parkerModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding parker', feedbackItem));
        })
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let lease = formData.lease;
      for(let leaseData of lease) {
        let error;
        if(!leaseData['seasonID']) {
          error = 'Please select valid product before proceed';
        } else if(!this.pageFees[leaseData['seasonID']] || !leaseData['seasonFeesID']) {
          error = 'Please select product with valid season fees before proceed';
        } else if(!leaseData['parkerID']) {
          error = 'Please select valid parker before proceed';
        }

        if(error) {
          this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(error);
          $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
          return true;
        }
      }
      this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError();

      let selectedDate = helper.parseDateTime(formData['_commencementDate']);
      let commencementDate1 = this.pageCarparkSeason['CommencementDate1'];
      let commencementDate2 = this.pageCarparkSeason['CommencementDate2'];
      if(commencementDate1 && commencementDate2) {
        if(selectedDate.date() !== commencementDate1 && selectedDate.date() !== commencementDate2) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate1} or ${commencementDate2} of the month`);
          return true;
        }
      } else if(commencementDate1) {
        if(selectedDate.date() !== commencementDate1) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate1} of the month`);
          return true;
        }
      } else if(commencementDate2) {
        if(selectedDate.date() !== commencementDate2) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate2} of the month`);
          return true;
        }
      }
      this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError();

      if(!formData['agreeEmailBill'] || !formData['agreeEmailCorrespondences']) {
        this.$refs['pageForm'].$refs['jt-form-element-agreeEmailCorrespondences'][0].setInputError('To proceed you must agree to the billing and correspondence instructions.');
        return true;
      }

      if(!formData['agreeTNCandPP']) {
        this.$refs['pageForm'].$refs['jt-form-element-agreeTNCandPP'][0].setInputError('To proceed you must agree to terms & conditions and privacy policy.');
        return true;
      }

      if(formData['applicationType'] === 'Personal' && (formData['accessCard'] === undefined || formData['accessCard'] === null)) {
        this.$refs['pageForm'].$refs['jt-form-element-accessCard'][0].setInputError('Please select access card delivery option.');
        return true;
      }
    },

    isTenant() {
      let formData = this.$refs['pageForm'].formData;
      return formData['tenant'] = this.pageTenant.find(k => helper.compareID(k.carparkID, formData['carparkID']) && helper.compareID(k.customerID, formData['customerID']));
    },
    addTenant(data) {
      let formData = this.$refs['pageForm'].formData;
      if(this.isTenant()) {
        // already is tenant
        this.addApplication(data);
      } else if(!formData['applicationCarparkTenant']) {
        // didn't select as tenant
        this.addApplication(data);
      } else {
        let feedbackItem = 'customer as tenant';
        this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
        this.$http
          .post(
            helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/tenant/',
            querystring.stringify({'carparkID':formData['carparkID'], 'customerID':formData['customerID']}),
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
            this.addApplication(data);
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
          })
      }
    },
    addApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['carparkID'] = formData['carparkID'];
      temp['customerID'] = formData['customerID'];
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).unix();
      temp['accessCard'] = formData['accessCard'];
      temp['leases'] = JSON.stringify(formData['lease']);
      // temp['invoiceData'] = JSON.stringify(formData['lease']);

      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;

      let feedbackItem = 'parking license application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          // helper.SERVER_URL + '/api2/invoice',
          helper.API_URL + '/api2/licenseApplication/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).unix();
      temp['accessCard'] = formData['accessCard'];
      temp['leases'] = JSON.stringify(formData['lease']);

      let feedbackItem = 'parking license application';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseApplication/update',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      let url = this.$route.query.pending ? helper.WEB_URL + '/plApplicationPending' : helper.WEB_URL + '/plApplication';
      if(window.location.href.includes('localhost')) {
        return;
      }
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },

    async onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'applicationType') {
        this.$refs['pageFeedback'].setFeedbackError();
        this.$refs['pageForm'].formData['customerID'] = null;
        this.onApplicationTypeChange();
        this.hideFormFromKey('sectionApplicationInformation');
      } else if(formParameter.key === 'customerID') {
        if(formData[formParameter.key] === '-1') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            helper.redirect({ path: helper.WEB_URL + '/personalForm', query: { redirect: this.$route.path.substr(1) }});
          } else {
            helper.redirect({ path: helper.WEB_URL + '/companyForm', query: { redirect: this.$route.path.substr(1) }});
          }
          return;
        }

        this.onApplicationCustomerChange();
      } else if(formParameter.key === 'carparkID') {
        this.pageCarparkSeason = null;
        this.pageSeason = null;
        this.pageBay = null;

        this.onApplicationCarparkOrCustomerChange();
        this.onApplicationCarparkTenantChange();
        this.loadCarparkSeasonSetting();
      } else if(formParameter.key === 'applicationCarparkTenant') {
        this.onApplicationCarparkTenantChange();
      } else if(formParameter.key === '_commencementDate') {
        formData.lease.forEach(leaseData => {
          leaseData['seasonFees'] = null;
        });
        this.onApplicationCarparkTenantChange();
        this.calculateParkingFees();
      } else if(formParameter.key === 'paymentPlan') {
        this.calculateParkingFees();
      }
    },

    onApplicationTypeChange() {
      let formData = this.$refs['pageForm'].formData;
      if(formData['applicationType'] === 'Personal') {
        PARAM_MAP['sectionCustomerProfile'].form_section = 'Personal Profile';
        PARAM_MAP['customerID'].text = 'Personal Full Name';

        let personalProfile = this.pageCustomer.filter(k => !k.isCompany) || [];
        if(helper.checkRoleIsParker()) {
          if(!personalProfile.find(k => !k.operatorID)) {
            personalProfile = [].concat({id: -1, name: 'Create new personal profile'}, personalProfile);
          }
        } else {
          personalProfile = [].concat({id: -1, name: 'Create new personal profile'}, personalProfile);
        }
        helper.inputSelectSetOption(PARAM_MAP['customerID'], personalProfile);

        this.$refs['pageTableLease'].setLeaseEnableAction(false, this.$refs['pageForm'].formIsAdd);
        if(this.$refs['pageForm'].formIsAdd) {
          if(formData['lease'].length > 1) {
            formData['lease'].splice(1);
          }
        }
      } else {
        PARAM_MAP['sectionCustomerProfile'].form_section = 'Company Profile';
        PARAM_MAP['customerID'].text = 'Company Name';

        let companyProfile = this.pageCustomer.filter(k => k.isCompany) || [];
        if(helper.checkRoleIsParker()) {
          if(!companyProfile.find(k => !k.operatorID)) {
            companyProfile = [].concat({id: -1, name: 'Create new company profile'}, companyProfile);
          }
        } else {
          companyProfile = [].concat({id: -1, name: 'Create new company profile'}, companyProfile);
        }
        helper.inputSelectSetOption(PARAM_MAP['customerID'], companyProfile);

        this.$refs['pageTableLease'].setLeaseEnableAction(this.$refs['pageForm'].formIsAdd, this.$refs['pageForm'].formIsAdd);
      }
    },
    onApplicationCustomerChange() {
      let formData = this.$refs['pageForm'].formData;
      this.pageParker = null;

      if(!this.$refs['pageForm'].formIsAdd) {
        helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
        this.onApplicationCarparkOrCustomerChange();
        this.onApplicationCarparkTenantChange();
        return;
      }

      // TODO kw1 also get existing application with status Pending Approval 
      // TODO kw1 get existing license with status Pending Approval / Pending Initial Payment / Active / Reinstated Request 
      let existingLicenseList = this.pageLicenseAll.filter(j => {
        if(j.status === 'Pending' ||
          j.status === 'Pending Approval' ||
          j.status === 'Pending Initial Payment' ||
          j.status === 'Active' ||
          j.status === 'Reinstated Request') {
          return helper.compareID(j.customerID, formData['customerID']);
        }
      });
      let existingApplicationList = this.pageApplicationAll.filter(j => {
        if(j.status1=== 'Pending Approval') {
          return helper.compareID(j.customerID, formData['customerID']);
        }
      });

      // TODO kw1 show only car park with start date not in future, not do-able because value saved in /seasonSetting
      // TODO kw1 show only car park with end date not in past, not do-able because value saved in /seasonSetting
      // TODO kw1 show only car park with SuspendApplication set to false, not do-able because value saved in /seasonSetting
      // let validCarpark = this.pageCarpark.filter(k => moment(k['startDate']) < moment());

      let existingOperatorID = [];
      let selectedCustomer;
      let isParker = helper.checkRoleIsParker();
      if(isParker) {
        this.pageCustomer.forEach(k => {
          if(helper.compareID(k.id, formData['customerID'])) {
            selectedCustomer = k;
          }
          if(k.operatorID) {
            existingOperatorID.push(k.operatorID);
          }
        });
      }
      
      let keepInSelection = helper.checkRoleIsParker() ? false : true;
      // keepInSelection = true;
      let validCarpark = this.pageCarpark.filter(k => {
        if(!k['isEnable']) {
          k['_disabled'] = 'Disabled';
          return keepInSelection;
        }
        if(k['SuspendApplication']) {
          k['_disabled'] = 'Suspended';
          return keepInSelection;
        }
        if(k['startDate'] && moment(k['startDate']) > moment()) {
          k['_disabled'] = 'Not Started';
          return keepInSelection;
        }
        if(k['endDate'] && helper.parseDateTime(k['endDate']) <= moment().startOf('day')) {
          k['_disabled'] = 'Stopped';
          return keepInSelection;
        }
        if(existingLicenseList.find(j => helper.compareID(j.carparkID, k.id))) {
          k['_disabled'] = 'Existing License';
          return true;
          return keepInSelection;
        }
        if(existingApplicationList.find(j => helper.compareID(j.carparkID, k.id))) {
          k['_disabled'] = 'Existing Application';
          return true;
          return keepInSelection;
        }
        if(isParker) {
          if(selectedCustomer.operatorID) {
            // operator added parker, can only select car park from same operator
            if(!helper.compareID(selectedCustomer.operatorID, k.operatorID)) {
              k['_disabled'] = 'Different Operator Profile';
              return false;
              return keepInSelection;
            }
          } else {
            // self added parker, can only select car park from operator which parker doesn't have profile
            if(existingOperatorID.includes(k.operatorID)) {
              k['_disabled'] = 'Existing Operator Profile';
              return false;
              return keepInSelection;
            }
          }
        }

        k['_disabled'] = null;
        return true;
      });
      // validCarpark = validCarpark.filter(k => !existingLicenseList.find(j => helper.compareID(j.carparkID, k.id)));
      // validCarpark = validCarpark.filter(k => !existingApplicationList.find(j => helper.compareID(j.carparkID, k.id)));
      helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], validCarpark);

      if(validCarpark.find(k => helper.compareID(k.id, formData['carparkID']) && !k._disabled)) {
        this.loadParker();
      } else {
        formData['carparkID'] = null;
        this.hideFormFromKey('applicationCarparkTenant');
      }

      this.onApplicationCarparkOrCustomerChange();
      this.onApplicationCarparkTenantChange();
    },
    onApplicationCarparkOrCustomerChange() {
      let formData = this.$refs['pageForm'].formData;
      if(this.isTenant()) {
        PARAM_MAP['applicationCarparkTenant'].form_input_attr = {disabled : 1};
        formData['applicationCarparkTenant'] = 1;
      } else {
        PARAM_MAP['applicationCarparkTenant'].form_input_attr = null;
        formData['applicationCarparkTenant'] = 0;
      }
      // radio button won't update??
      // this.$refs['pageForm'].$forceUpdate();
    },
    onApplicationCarparkTenantChange() {
      if(this.pageSeason) {
        // if is old application then season might be missing after filter by enable and tenant
        if(!this.$refs['pageForm'].formIsAdd) {
          this.$refs['pageTableLease'].setSeasonData(this.pageSeason);
          return;
        }

        let formData = this.$refs['pageForm'].formData;
        // TODO kw1 entitle only product
        // TODO kw1 operator - public visible product
        let keepInSelection = helper.checkRoleIsParker() ? false : true;
        let usableSeason = this.pageSeason.filter(k => {
          if(!k['isEnable']) {
            k['_disabled'] = 'Disabled'
            return keepInSelection;
          }
          if(k['startDate'] && helper.parseDateTime(k['startDate']) > helper.parseDateTime(formData['_commencementDate'])) {
            k['_disabled'] = 'Not Started'
            return keepInSelection;
          }
          if(k['stopDate'] && helper.parseDateTime(k['stopDate']) <= moment().startOf('day')) {
            k['_disabled'] = 'Stopped'
            return keepInSelection;
          }
          if(k['isTenant']) {
            if(!parseInt(formData['applicationCarparkTenant'])) {
              k['_disabled'] = 'Tenant Only'
              return keepInSelection;
            }
          } else {
            if(parseInt(formData['applicationCarparkTenant'])) {
              k['_disabled'] = 'Non-tenant Only'
              return keepInSelection;
            }
          }
          if(!k['isPublic']) {
            if(helper.checkRoleIsParker()) {
              k['_disabled'] = 'Non-Public'
              return keepInSelection;
            }
          }
          if(k['entitleOnly']) {
            if(!formData['tenant']) {
              k['_disabled'] = 'Entitlement Only'
              return helper.checkRoleIsParker() ? false : keepInSelection;
            }
            
            let entitlement = this.pageEntitlement.find(j => 
              helper.compareID(j['seasonID'], k['id']) 
              && helper.compareID(j['tenantID'], formData['tenant']['id']))
            if(!entitlement || !entitlement.bayCount) {
              k['_disabled'] = 'Entitlement Unallocated'
              return keepInSelection;
            }

            let usedEntitlementBay = this.pageBay.filter(j => j.seasonID === k.id && j.leaseID && helper.compareID(j['customerID'], formData['customerID'])).length;
            k['_actualBayAvailable'] = entitlement.bayCount - usedEntitlementBay;
          } else {
            k['_actualBayAvailable'] = k['_bayAvailable'];
          }

          if(!k['_actualBayAvailable']) {
            k['_disabled'] = 'Insufficient Bay' 
            return true;
            return keepInSelection;
          }
          
          k['_disabled'] = null;
          return true;
        });

        this.$refs['pageTableLease'].setSeasonData(usableSeason);

        // radio button will select both???
        // this.$refs['pageForm'].$forceUpdate();
      }

      if(!this.$refs['pageTableLease'].tableSeason || this.$refs['pageTableLease'].tableSeason.length === 0) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('No product available.');
      } else {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError();
      }
    },
    onApplicationLeaseSelect(leaseDataIndex, newSeasonID, oldSeasonID) {
      this.$refs['pageFeedback'].setFeedbackMessage();

      if(newSeasonID) {
        this.pageFees[newSeasonID] = this.pageFees[newSeasonID] || undefined;
      }

      let formData = this.$refs['pageForm'].formData;

      // cannot depend on leaseDataIndex because if delete lease on top will messed up
      // let temp = formData.lease.filter(k => k.tandemIndex !== leaseDataIndex);
      // formData.lease.splice(0);
      // temp.forEach(k => formData.lease.push(k));
      
      let selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, oldSeasonID)) || {};
      // if previsouly selected season is tandem reserved 
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease[leaseDataIndex]['pairID'] = null;
        formData.lease.splice(leaseDataIndex + 1, selectedSeason['baySlots'] - 1);
      }

      selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, newSeasonID)) || {};
      // if newly selected season is tandem reserved
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease[leaseDataIndex]['pairID'] = new moment().valueOf();
        for(var i=1; i<selectedSeason['baySlots']; i++) {
          formData.lease.splice(leaseDataIndex + 1 , 0, { seasonID: selectedSeason.id, tandemIndex: leaseDataIndex, parkerID: null, pairID: formData.lease[leaseDataIndex]['pairID'] });
          // formData.lease.push({ seasonID: selectedSeason.id });
        }
      }

      this.calculateParkingFees();
    },
    onApplicationLeaseRemove(leaseDataIndex, seasonID) {
      if(seasonID) {
        this.pageFees[seasonID] = this.pageFees[seasonID] || undefined;
      }

      let formData = this.$refs['pageForm'].formData;
      let selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, seasonID));
      // if selected season is tandem reserved
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease.splice(leaseDataIndex, selectedSeason['baySlots'] - 1);
      }
      this.calculateParkingFees();
    },

    onApplicationApproveClick() {
      this.approvalAction = 'approve';
      this.approvalText = 'Approve parking license application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Approve Application');
    },
    onApplicationRejectClick() {
      this.approvalAction = 'reject';
      this.approvalText = 'Reject parking license application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectLabel = 'Reason of Reject';
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Reject Application');
    },
    onApplicationPendingClick() {
      this.approvalAction = 'pending';
      this.approvalText = 'Change parking license application ' + this.pageApplication + ' to Pending Approval';
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Pending Application');
    },
    onApplicationVoidClick() {
      this.approvalAction = 'void';
      this.approvalText = 'VOID parking license application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectLabel = 'Reason to VOID';
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'VOID Application');
    },
    onApplicationPaidClick() {
      this.approvalAction = 'complete';
      this.approvalText = 'Complete parking license application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Complete Application');
    },
    pageApprovalModalConfirm() {
      if(this.approvalAction === 'reject') {
        if(!this.approvalRejectReason && !window.location.href.includes('localhost')) {
          this.approvalRejectReasonError = 'Reason of Reject cannot be empty';
          return;
        } else {
          this.approvalRejectReasonError = '';
        }
      } else if(this.approvalAction === 'void') {
        if(!this.approvalRejectReason && !window.location.href.includes('localhost')) {
          this.approvalRejectReasonError = 'Reason to VOID cannot be empty';
          return;
        } else {
          this.approvalRejectReasonError = '';
        }
      }

      this.updateApplicationStatus(this.approvalAction);
    },
    updateApplicationStatus(action) {
      this.$refs['pageApprovalModal'].setModalClose('');

      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license application ' + this.pageApplication + ' status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseApplication/' + action,
          querystring.stringify({ leases: JSON.stringify(formData['lease']), rejectReason: this.approvalRejectReason }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasApprovePermission() {
      return helper.hasPermission(this.permission + '.approve', false);
    },
    hasRejectPermission() {
      return helper.hasPermission(this.permission + '.reject', false);
    },
    hasVoidPermission() {
      return helper.hasPermission(this.permission + '.void', false);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLApplicationForm.vue